import { useSelector } from 'react-redux'
import type { RootState } from 'state/store.types'

export const useLocation = () =>
	useSelector((state: RootState) => state.router.location as any)
